const gtag = {
    event: (action, params) => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', action, params);
        }
    }
}

export default gtag;